import { render } from "./InfoModel.vue?vue&type=template&id=764a1bda&scoped=true"
import script from "./InfoModel.vue?vue&type=script&lang=js"
export * from "./InfoModel.vue?vue&type=script&lang=js"

import "./InfoModel.vue?vue&type=style&index=0&id=764a1bda&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764a1bda"]])

export default __exports__